import Core from '../../../../shared/pdf/PdfCore';
import PDF from '../../../../shared/pdf/PdfA4';
export default {
    header(){
        return [
            { text: 'ADVANCE TAX INVOICE' }
        ]
    },
    print(){
        let content = [
            ...this.header()
        ];
        PDF.loadPdf(content);
    }
}